export const Theme = {
    Default: '',
    Teams: 'Teams',
    LmsBasics: 'LmsBasics',
    Canvas: 'Canvas',
};
export default Theme;
